import type { ReactNode } from 'react'

// Stacked stat: big value + small label. Used on Perfil (matches / streak / no-shows).
// Values must share ONE baseline across sibling pills even when a label wraps to
// two lines (justify-start + a 2-line label reserve — 36px ≈ 2 × 13px × 1.4lh).
export function StatPill({ value, label }: { value: ReactNode; label: string }) {
  return (
    <div className="flex-1 flex flex-col items-center justify-start py-3 rounded-[var(--radius-card)] bg-[var(--surface-card)] border border-[var(--line)]">
      <span className="text-[length:var(--fs-2xl)] font-bold leading-none tabular-nums">{value}</span>
      <span className="text-[length:var(--fs-xs)] text-[color:var(--fg-muted)] mt-1 text-center leading-[1.4] min-h-[36px]">
        {label}
      </span>
    </div>
  )
}
